export default __webpack_public_path__ + "static/media/logo-patrocinador2.cb7bb029.svg";